/**
 * @About
 * This file contains all type of validation.
 */
export const mobileNoRegex = /^[0-9\b]+$/;
//  export  const ValidaiteUrl = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;

